export default {
  buttons: {
    more_payment_methods: 'Plus de moyens de paiement',
  },
  toasts: {
    processing:
      'Traitement des informations de paiement en cours. Nous vous informerons une fois le traitement terminé.',
    failed: 'Échec du traitement des informations de paiement. Veuillez essayer un autre moyen de paiement.',
    failed_to_load: "Le formulaire de paiement n'a pas pu être chargé. Veuillez recharger la page et réessayer.",
    failed_to_save_payment_method: "Échec de l'enregistrement du moyen de paiement",
    failed_to_create_checkout_session: "Une erreur s'est produite, veuillez réessayer",
  },
};
